import AuthShell from './AuthShell';

function AuthLayout({ children }) {
  return (
    <AuthShell
      brandEyebrow="PandaSeller"
      brandTitle="The performance hub for modern sellers."
      brandBody="Sync Amazon orders, run procurement, and keep listings moving — one workspace."
    >
      {children}
    </AuthShell>
  );
}

export default AuthLayout;
